module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-wetsuit--shorty-16a4330f06f9b49ec411fc6a88b2f0f5.svg";